import React, { Component } from "react";
import axios from "axios";
import Alert from "react-s-alert";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { TopTextReusableComponent } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import {
  NewInputText,
  NewSelectBoxInput,
} from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
} from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { RestaurantMapSetupValidation } from "../../../../../store/validation/allValidationFile/onboardingProcessValidation/RestaurantMapSetupValidation";
import InputNumberFunc from "../../../../../function/InputNumberFunc";
import { InputCharacterCheck } from "../../../../../function/InputCharNumCheckFunc";
import { DropDownBoxCrret } from "../../../../reusableComponents/dropDownButtonReusable/DropDownButton";
import { AddButtonIconComponent } from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

import { TimeZoneCustom } from "./TimeZoneCustom";
import { CurrencyPicker } from "./CurrencyPicker";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import countryJson from "../../../../localization/country.json";

//import { serverApi } from "../../../../config/Keys";
import isEmpty from "../../../../../store/validation/is-Empty";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import { superadmin_create_and_update_restaurant } from "../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";

const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);

export class SuperAdminAddBusinessDetails extends Component {
  fileObj = [];
  fileArray = [];

  constructor(props) {
    super(props);
    this.state = {
      actionButton: false,
      dropDownBox: false,
      vendor_id: "",
      localizationText: "",
      hasSetMapProps: false,
      loader: false,
      google_place_id: "",
      name: "",
      address: "",
      city: "",
      area: "",
      pinCode: "",
      businessState: "",
      // location: {
      //   latitude: "",
      //   longitude: "",
      // },
      location: {
        coordinates: ["", ""],
      },
      country_code: "",
      contact_detail: [{ country_code: "", mobile_no: "" }],
      enquiry_email: [""],
      emailError: "",
      phoneError: "",
      country: "",
      currency: "",
      timezone: "",
      errors: {},
      error: null,
      errorValue: false,
      isLoading: false,
      file: null,
    };
  }

  async componentDidMount() {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    let adminVendorId = this.props?.editDataAction
      ? this.props?.editData?.vendor_id
      : JSON.parse(localStorage.getItem("vendorId"));
    const formData = {
      vendor_id: adminVendorId,
    };
    if (adminVendorId !== null || adminVendorId !== undefined) {
      this.props.superadmin_create_and_update_restaurant(formData);
      this.setState({
        vendor_id: formData.vendor_id,
      });
    }
    if (onboarding?._id) {
      this.setState({
        google_place_id: !isEmpty(onboarding?.google_place_id)
          ? onboarding?.google_place_id
          : "",
        address: !isEmpty(onboarding?.restaurant_address)
          ? onboarding?.restaurant_address
          : "",
        city: !isEmpty(onboarding?.city) ? onboarding?.city : "",
        area: !isEmpty(onboarding?.area) ? onboarding?.area : "",
        pinCode: !isEmpty(onboarding?.pinCode) ? onboarding?.pinCode : "",
        businessState: !isEmpty(onboarding?.state) ? onboarding?.state : "",
        // location: !isEmpty(onboarding?.location)
        //   ? onboarding?.location
        //   : { latitude: "", longitude: "" },
        location:
          !isEmpty(onboarding?.location) &&
          !isEmpty(onboarding?.location.coordinates)
            ? {
                coordinates: [
                  onboarding?.location.coordinates[1],
                  onboarding?.location.coordinates[0],
                ],
              }
            : { coordinates: ["", ""] },

        page_completed_till: 1,

        name: !isEmpty(onboarding?.restaurant_name)
          ? onboarding?.restaurant_name
          : "",
        enquiry_email: !isEmpty(onboarding?.enquiry_email)
          ? onboarding?.enquiry_email
          : [""],
        contact_detail: !isEmpty(onboarding?.contact_detail)
          ? onboarding?.contact_detail
          : [{ country_code: "", mobile_no: "" }],
        country: !isEmpty(onboarding?.country) ? onboarding?.country : "",
        currency: !isEmpty(onboarding?.currency) ? onboarding?.currency : "",
        timezone: !isEmpty(onboarding?.timezone) ? onboarding?.timezone : "",
      });
    }

    this.setState({ isLoading: true });
    axios
      .get("https://ipapi.co/json")
      .then((result) =>
        //console.log(result.data)
        this.setState({
          country_code: result.data.country_calling_code,
          country: result.data.country_name,
          currency: result.data.currency,
          timezone: result.data.timezone,
          isLoading: false,
        })
      )
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );

    if (
      this.props?.location?.state !== null &&
      this.props?.location?.state !== undefined
    ) {
      if (
        !isEmpty(this.props?.location?.state?.formData?.data) !==
          this.state.secondScreen &&
        !isEmpty(this.props?.location?.state?.formData?.actionButton) !==
          this.state.actionButton
      ) {
        this.setState({
          secondScreen: this.props?.location?.state?.formData?.data,
          actionButton: this.props?.location?.state?.formData?.actionButton,
        });
      }
    }
  }

  componentDidUpdate() {
    if (
      isEmpty(this.state.country) ||
      isEmpty(this.state.currency) ||
      isEmpty(this.state.timezone)
    ) {
      axios.get("https://ipapi.co/json").then((result) =>
        //console.log(result.data)
        this.setState({
          country_code: result.data.country_calling_code,
          country: result.data.country_name,
          currency: result.data.currency,
          timezone: result.data.timezone,
          isLoading: false,
        })
      );
    }
    if (this.props.auth.loader !== this.state.loader) {
      this.setState({
        loader: this.props.auth.loader,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    let onboarding = nextProps?.editDataAction
      ? nextProps?.editData
      : nextProps?.onboardingData;
    if (
      onboarding._id &&
      nextProps.auth.user.VendorUser &&
      !isEmpty(onboarding.location) &&
      !isEmpty(onboarding.location.coordinates)
    ) {
      if (
        (!isEmpty(onboarding.location) &&
          !isEmpty(onboarding.location.coordinates[1]) &&
          !isEmpty(onboarding.location.coordinates[0]) &&
          !isEmpty(nextProps.auth.user.VendorUser.country_code) &&
          !nextState.hasSetMapProps) ||
        nextState.location.coordinates[0] !==
          onboarding.location.coordinates[1] ||
        nextState.location.coordinates[1] !== onboarding.location.coordinates[0]
      ) {
        return {
          localizationText: !isEmpty(
            nextProps.auth.user.VendorUser &&
              nextProps.auth.user.VendorUser.country_code &&
              nextProps.auth.user.VendorUser.country
          )
            ? nextProps.auth.user.VendorUser.country_code +
              nextProps.auth.user.VendorUser.country
            : "+91IN",
          google_place_id: !isEmpty(onboarding.google_place_id)
            ? onboarding.google_place_id
            : "",
          address: !isEmpty(onboarding.restaurant_address)
            ? onboarding.restaurant_address
            : "",
          city: !isEmpty(onboarding.city) ? onboarding.city : "",
          area: !isEmpty(onboarding.area) ? onboarding.area : "",
          pinCode: !isEmpty(onboarding.pinCode) ? onboarding.pinCode : "",
          businessState: !isEmpty(onboarding.state) ? onboarding.state : "",
          // location: !isEmpty(onboarding.location)
          //   ? onboarding.location
          //   : { latitude: "", longitude: "" },
          location:
            !isEmpty(onboarding.location) &&
            !isEmpty(onboarding.location.coordinates)
              ? {
                  coordinates: [
                    onboarding.location.coordinates[1],
                    onboarding.location.coordinates[0],
                  ],
                }
              : { coordinates: ["", ""] },

          page_completed_till: 1,

          name: !isEmpty(onboarding.restaurant_name)
            ? onboarding.restaurant_name
            : "",
          enquiry_email: !isEmpty(onboarding.enquiry_email)
            ? onboarding.enquiry_email
            : [""],
          contact_detail: !isEmpty(onboarding.contact_detail)
            ? onboarding.contact_detail
            : [{ country_code: "", mobile_no: "" }],
          country: !isEmpty(onboarding.country) ? onboarding.country : "",
          currency: !isEmpty(onboarding.currency) ? onboarding.currency : "",
          timezone: !isEmpty(onboarding.timezone) ? onboarding.timezone : "",
          // restaurant_description: !isEmpty(
          //   onboarding.restaurant_description
          // )
          //   ? onboarding.restaurant_description
          //   : "",
          // logo_url: !isEmpty(onboarding.logo_url)
          //   ? onboarding.logo_url
          //   : [],
          // restaurant_pictures: !isEmpty(onboarding.restaurant_pictures)
          //   ? onboarding.restaurant_pictures
          //   : [],
          // restaurant_pictures: [],
          // this.state.restaurant_pictures,
          // things_nearby: onboarding.things_nearby,
          hasSetMapProps: true,
        };
      }
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextState.errors,
      };
    }
    return null;
  }

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  handleOnChange = (value) => {
    this.setState({ country_code: "+" + value, actionButton: 3 });
  };

  handleChange = (countryTimeZone) => {
    this.setState({
      timezone: countryTimeZone,
      actionButton: true,
    });
  };

  selecthandleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  onChange = (e) => {
    this.props.clear_all_errors();
    if (
      e.target.name === "restaurant_description" ||
      e.target.name === "things_nearby"
    ) {
      let caps = e.target.value;
      caps = caps.charAt(0).toUpperCase() + caps.slice(1);
      let dataSet = caps;
      this.setState({
        // [e.target.name]: e.target.value
        [e.target.name]: dataSet,
        actionButton: true,
      });
    } else {
      let data = e.target.value.split(" ");
      let newarray1 = [];
      for (let x = 0; x < data.length; x++) {
        newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
      }
      let newData = newarray1.join(" ");
      this.setState({
        [e.target.name]: newData,
        actionButton: true,
      });
    }
  };

  onChangePinCode = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[
        e.target.name
      ] = `*Fields can’t be blank. Please enter your ${e.target.name}`;
      this.setState({ errorValue: true });
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  onActionButtonClick = (e) => {
    this.props.history.push({
      pathname: this.props?.editDataAction
        ? "/admin_edit_point_of_contact"
        : "/addvendorpointofcontact",
    });
  };

  /**************************
   * @DESC - ONCHANGE SCREEN HANDLER
   ***************************/
  onChangeScreen = (e) => {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    e.preventDefault();
    if (onboarding && onboarding.enquiry_email.length > 0) {
      let formData = {
        vendor_id: this.state.vendor_id,
        id: onboarding._id,
        restaurant_name: this.state.name,
        restaurant_address: this.state.address,
        city: this.state.city,
        area: this.state.area,
        pinCode: this.state.pinCode,
        state: this.state.businessState,
        enquiry_email: this.state.enquiry_email,
        contact_detail: this.state.contact_detail,
        country: this.state.country,
        currency: this.state.currency,
        timezone: this.state.timezone,
      };
      this.props.superadmin_create_and_update_restaurant(formData);
      this.props.history.push({
        pathname: this.props?.editDataAction
          ? "/admin_edit_point_of_contact"
          : "/addvendorpointofcontact",
      });
    } else {
      let formData = {
        vendor_id: this.state.vendor_id,
        id: onboarding._id,
        restaurant_name: this.state.name,
        restaurant_address: this.state.address,
        city: this.state.city,
        area: this.state.area,
        pinCode: this.state.pinCode,
        state: this.state.businessState,
        enquiry_email: this.state.enquiry_email,
        contact_detail: this.state.contact_detail,
        country: this.state.country,
        currency: this.state.currency,
        timezone: this.state.timezone,
        page_completed_till: 2,
      };
      this.props.superadmin_create_and_update_restaurant(formData);
      this.props.history.push({
        pathname: this.props?.editDataAction
          ? "/admin_edit_point_of_contact"
          : "/addvendorpointofcontact",
      });
    }
  };

  backbuttonClickhandler = (e) => {
    e.preventDefault();
    this.setState({
      actionButton: true,
    });
  };

  /*****************************************
   * @DESC - Multiple Email Handlers
   ******************************************/
  onEmailAddHandler = (e) => {
    e.preventDefault();
    let enquiry_email = this.state.enquiry_email;
    if (enquiry_email.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      enquiry_email[enquiry_email.length - 1] === "" ||
      !validEmailRegex.test(enquiry_email[enquiry_email.length - 1])
    ) {
      const { errors, isValid } = RestaurantMapSetupValidation(this.state);
      errors.enquiry_email = "Email is Required";
      if (!isValid) {
        this.setState({
          errors: errors,
        });
      }
    } else {
      enquiry_email.push("");
      this.setState({
        enquiry_email: enquiry_email,
      });
    }
  };

  /*************************************
   * @DESC Email Change Handlers
   ************************************/
  onEmailChangeHandler = (index) => (e) => {
    let enquiry_email = this.state.enquiry_email;
    if (enquiry_email.includes(e.target.value)) {
      alert("Email Already Exits");
    } else {
      enquiry_email[index] = e.target.value;
      this.setState({
        enquiry_email: enquiry_email,
        emailError: "",
        errors: {},
        actionButton: true,
      });
    }
  };

  /*************************************
   * @DESC Email Delete Handlers
   ************************************/
  onEmailDeleteHandler = (index) => (e) => {
    let enquiry_email = this.state.enquiry_email;
    if (enquiry_email.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      enquiry_email.splice(index, 1);
      this.setState({
        enquiry_email: enquiry_email,
      });
    }
  };

  /*****************************************
   * @DESC - Multiple Phone Handlers
   ******************************************/
  onPhondeAddHandler = (e) => {
    e.preventDefault();
    let contact_detail = this.state.contact_detail;
    if (contact_detail.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      contact_detail[contact_detail.length - 1].mobile_no === "" ||
      contact_detail[contact_detail.length - 1].mobile_no.length < 9
    ) {
      const { errors, isValid } = RestaurantMapSetupValidation(this.state);
      errors.mobile_no = "Phone is required";
      if (!isValid) {
        this.setState({
          errors: errors,
        });
      }
    } else {
      let obj = {
        country_code: this.state.country_code,
        mobile_no: "",
      };
      contact_detail.push(obj);
      this.setState({ contact_detail: contact_detail });
    }
  };

  /*************************************
   * @DESC Phone Change Handlers
   ************************************/
  onPhoneChangeHandler = (index) => (e) => {
    // let contact_detail = this.state.contact_detail;
    // contact_detail[index].mobile_no = e.target.value.slice(
    //   0,
    //   e.target.maxLength
    // );
    let contact_detail = this.state.contact_detail;
    if (contact_detail.some((diner) => diner.mobile_no === e.target.value)) {
      alert("Phone Number Already Exits");
    } else {
      contact_detail[index].country_code =
        contact_detail[index].country_code === ""
          ? this.state.country_code
          : contact_detail[index].country_code;
      contact_detail[index].mobile_no = e.target.value.slice(
        0,
        e.target.maxLength
      );
      this.setState({
        contact_detail: contact_detail,
        phoneError: "",
        errors: {},
        actionButton: true,
      });
    }
  };

  /*************************************
   * @DESC Country Code Handlers
   ************************************/
  onCountryCodeChangeHandler = (index) => (e) => {
    let contact_detail = this.state.contact_detail;
    contact_detail[index].country_code = e.target.value;
    this.setState({
      contact_detail: contact_detail,
      actionButton: true,
    });
  };

  /*************************************
   * @DESC Phone Number Delete Handlers
   ************************************/
  onPhoneDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let contact_detail = this.state.contact_detail;
    if (contact_detail.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      contact_detail.splice(index, 1);
      this.setState({ contact_detail: contact_detail, errors: {} });
    }
  };

  /************************************
   * @DESC Drop Down Box Handler
   ***********************************/
  dropDownBoxClick = (e) => {
    e.preventDefault();
    this.setState({
      dropDownBox: !this.state.dropDownBox,
    });
  };

  // async
  handleSubmit = (e) => {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    e.preventDefault();
    if (onboarding._id) {
      let formData = {
        vendor_id: this.state.vendor_id,
        id: onboarding._id,
        restaurant_name: this.state.name,
        restaurant_address: this.state.address,
        city: this.state.city,
        area: this.state.area,
        pinCode: this.state.pinCode,
        state: this.state.businessState,
        enquiry_email: this.state.enquiry_email,
        contact_detail: this.state.contact_detail,
        country: this.state.country,
        currency: this.state.currency,
        timezone: this.state.timezone,
        restaurant_description: this.state.restaurant_description,
        logo_url: this.state.logo_url.toString(),
        restaurant_pictures: this.state.restaurant_pictures,
        things_nearby: this.state.things_nearby,
        page_completed_till: 2,
      };
      this.props.superadmin_create_and_update_restaurant(formData);
      this.props.history.push({
        pathname: this.props?.editDataAction
          ? "/admin_edit_point_of_contact"
          : "/addvendorpointofcontact",
      });
    }
  };

  render() {
    if (this.state.loader) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    const {
      localizationText,
      actionButton,
      errors,
      enquiry_email,
      contact_detail,
      google_place_id,
      name,
      address,
      area,
      city,
      pinCode,
      businessState,
      country,
      currency,
      timezone,
      dropDownBox,
    } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div className="col-12 pl-5 pr-5">
                <div className="super_admin_add_vendor mb-4">
                  <h5 className="main_header_text">
                    {this.props?.editDataAction ? "Edit" : "Add"} Vendor
                  </h5>
                  <h4 className="font_20_m">Step : 2</h4>
                  <h4 className="font_20_m c_red mt-2 mb-1">
                    Business Details
                  </h4>
                  <hr className="hr_line" />
                </div>
                <TopTextReusableComponent
                  headingText="Business Details"
                  headingParagraph="Please Enter your Business Information only some of this information is displayed to the end User"
                />
                <Form
                  noValidate
                  // onSubmit={this.handleSubmit}
                >
                  <div className="mt-5 col-6 onboarding_process_screen-left-mapinside pl-0 pr-0">
                    <div className="col-12 p-0">
                      <NewInputText
                        name="name"
                        inputType="text"
                        onChange={this.onChange}
                        onFocusOut={this.onFocusOut}
                        value={this.state.name}
                        errorText={errors.name}
                        errorTrue={this.state.name === "" ? true : false}
                        labelText="Business Name*"
                        helpTextDisplay={true}
                        helperTextBottom="( Business names on Amealio need to be written as they appear on the board outside the establishment )"
                        controlClass={
                          errors.name !== ""
                            ? "outlined-error-helper-text"
                            : "outlined-helperText"
                        }
                      />
                    </div>
                    <div className="col-12 p-0">
                      <NewInputText
                        name="address"
                        onChange={this.onChange}
                        onFocusOut={this.onFocusOut}
                        rows="4"
                        multiline={true}
                        value={this.state.address}
                        errorText={errors.address}
                        errorTrue={this.state.address === "" ? true : false}
                        labelText="Business Address*"
                        helpTextDisplay={true}
                        helperTextBottom="( Business Address on Amealio need to be written to help users navigate to the place, please include all the details )"
                        controlClass={
                          errors.address !== ""
                            ? "outlined-error-helper-text"
                            : "outlined-helperText "
                        }
                      />
                    </div>
                    <div className="col-12 p-0">
                      <div className="row">
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <NewInputText
                            extraClass="mb-4"
                            name="pinCode"
                            inputType="number"
                            maxLength={
                              countryJson[localizationText] &&
                              countryJson[localizationText].pinCode
                            }
                            onChange={this.onChangePinCode}
                            onFocusOut={this.onFocusOut}
                            onKeyDown={InputNumberFunc}
                            value={this.state.pinCode}
                            errorText={errors.pinCode}
                            errorTrue={this.state.pinCode === "" ? true : false}
                            labelText="Pin/Zip Code*"
                            controlClass={
                              errors.pinCode !== ""
                                ? "outlined-error-helper-text"
                                : "outlined-number"
                            }
                          />
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <NewInputText
                            extraClass="mb-4"
                            name="area"
                            inputType="text"
                            onChange={this.onChange}
                            onFocusOut={this.onFocusOut}
                            onKeyDown={InputCharacterCheck}
                            value={this.state.area}
                            errorText={errors.area}
                            errorTrue={this.state.area === "" ? true : false}
                            labelText={
                              countryJson[localizationText] &&
                              countryJson[localizationText].areaCounty + "*"
                            }
                            controlClass={
                              errors.area !== ""
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <NewInputText
                            extraClass="mb-4"
                            name="city"
                            inputType="text"
                            onChange={this.onChange}
                            onFocusOut={this.onFocusOut}
                            onKeyDown={InputCharacterCheck}
                            value={this.state.city}
                            errorText={errors.city}
                            errorTrue={this.state.city === "" ? true : false}
                            labelText="City*"
                            controlClass={
                              errors.city !== ""
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <NewInputText
                            extraClass="mb-4"
                            name="businessState"
                            inputType="text"
                            onChange={this.onChange}
                            onFocusOut={this.onFocusOut}
                            onKeyDown={InputCharacterCheck}
                            value={this.state.businessState}
                            errorText={errors.businessState}
                            errorTrue={
                              this.state.businessState === "" ? true : false
                            }
                            labelText="State*"
                            controlClass={
                              errors.businessState !== ""
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>
                        {/* <div className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                          <NewInputText
                            name="area"
                            inputType="text"
                            onChange={this.onChange}
                            onFocusOut={this.onFocusOut}
                            onKeyDown={InputCharacterCheck}
                            value={this.state.area}
                            errorText={errors.area}
                            errorTrue={this.state.area === "" ? true : false}
                            // labelText={countryJson[localizationText].areaCounty}
                            controlClass={
                              errors.area !== ""
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                          <NewInputText
                            name="city"
                            inputType="text"
                            onChange={this.onChange}
                            onFocusOut={this.onFocusOut}
                            onKeyDown={InputCharacterCheck}
                            value={this.state.city}
                            errorText={errors.city}
                            errorTrue={this.state.city === "" ? true : false}
                            labelText="City"
                            controlClass={
                              errors.city !== ""
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                          <NewInputText
                            name="pinCode"
                            inputType="number"
                            // maxLength={countryJson[localizationText].pinCode}
                            onChange={this.onChangePinCode}
                            onFocusOut={this.onFocusOut}
                            onKeyDown={InputNumberFunc}
                            value={this.state.pinCode}
                            errorText={errors.pinCode}
                            errorTrue={this.state.pinCode === "" ? true : false}
                            labelText="Pin/Zip Code"
                            controlClass={
                              errors.pinCode !== ""
                                ? "outlined-error-helper-text"
                                : "outlined-number"
                            }
                          />
                        </div> */}
                      </div>
                    </div>
                    {this.state.enquiry_email.map((email, index) => (
                      <div className="row" key={index}>
                        <div className="col-9">
                          <NewInputText
                            extraClass="mb-4"
                            name="enquiry_email"
                            inputType="email"
                            onFocusOut={this.onFocusOut}
                            onChange={this.onEmailChangeHandler(index)}
                            value={email}
                            errorText={
                              !validEmailRegex.test(email) && !isEmpty(email)
                                ? "Please enter a valid email"
                                : null ||
                                  (email === "" &&
                                  errors.enquiry_email === "Email is Required"
                                    ? "*Fields can’t be blank. Please enter your Email"
                                    : null) ||
                                  (email === "" &&
                                    errors.enquiry_email ===
                                      "*Fields can’t be blank. Please enter your enquiry_email")
                                ? "*Fields can’t be blank. Please enter your Email"
                                : ""
                            }
                            errorTrue={
                              (!validEmailRegex.test(email) &&
                                !isEmpty(email)) ||
                              (email === "" &&
                                errors.enquiry_email === "Email is Required") ||
                              (email === "" &&
                                errors.enquiry_email ===
                                  "*Fields can’t be blank. Please enter your enquiry_email")
                                ? true
                                : false
                            }
                            labelText="Enquiry Email*"
                            controlClass={
                              (!validEmailRegex.test(email) &&
                                !isEmpty(email)) ||
                              (email === "" &&
                                errors.enquiry_email === "Email is Required") ||
                              (email === "" &&
                                errors.enquiry_email ===
                                  "*Fields can’t be blank. Please enter your enquiry_email")
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>
                        {this.state.enquiry_email.length > 1 ? (
                          <div className="col-3 restaurant_details_onboarding_minus_button">
                            <div>
                              <AddButtonIconComponent
                                buttonText="Delete"
                                onClick={this.onEmailDeleteHandler(index)}
                                fontIcon="fa fa-trash-o"
                                colorCss="delete"
                              />
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ))}
                    <div className="col-12 mb-3 pl-0 restaurant_details_onboarding_minus_button add_email_button bg-transparent mt-0">
                      <div>
                        <AddButtonIconComponent
                          buttonText="Add Another Email"
                          onClick={this.onEmailAddHandler}
                          fontIcon="fa fa-plus"
                          colorCss="blue"
                        />
                      </div>
                    </div>
                    {/* <Form.Label className="col-12 mt-3 pl-0 restaurant_details_onboarding_mobile_number">
                        Mobile Number
                      </Form.Label> */}
                    {this.state.contact_detail.map((phone, index) => (
                      <div className="row mb-4" key={index}>
                        <div className="col-4 col-sm-4 col-md-4 col-lg-3 col-xl-3">
                          <Form.Group
                            className="reusableInputComponent-main mb-0"
                            controlId={"country_code"}
                          >
                            <div className="input-phone-country-code-reusable">
                              <select
                                name="country_code"
                                value={phone.country_code}
                                onChange={this.onCountryCodeChangeHandler(
                                  index
                                )}
                              >
                                <option
                                  value={
                                    phone.country_code === ""
                                      ? this.state.country_code
                                      : phone.country_code
                                  }
                                >
                                  {phone.country_code === ""
                                    ? this.state.country_code
                                    : phone.country_code}
                                </option>
                                {getCountries().map((country) => (
                                  <option
                                    key={country}
                                    value={"+" + getCountryCallingCode(country)}
                                    onClick={this.onChangeCountry}
                                  >
                                    {en[country]} (+
                                    {getCountryCallingCode(country)})
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Form.Group>
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <NewInputText
                            extraClass="mb-0"
                            name="mobile_no"
                            inputType="number"
                            onFocusOut={this.onFocusOut}
                            onChange={this.onPhoneChangeHandler(index)}
                            value={phone.mobile_no}
                            maxLength="10"
                            onKeyDown={InputNumberFunc}
                            errorText={
                              phone.mobile_no === "" &&
                              errors.mobile_no === "Phone is required"
                                ? "*Fields can’t be blank. Please enter your valid mobile number"
                                : "" ||
                                  (phone.mobile_no === "" &&
                                    errors.mobile_no ===
                                      "*Fields can’t be blank. Please enter your mobile_no")
                                ? "*Fields can’t be blank. Please enter your valid mobile number"
                                : null ||
                                  (phone.mobile_no.length > 0 &&
                                    phone.mobile_no.length <= 9)
                                ? "Enter your valid mobile number"
                                : null
                            }
                            errorTrue={
                              (phone.mobile_no === "" &&
                                errors.mobile_no === "Phone is required") ||
                              (phone.mobile_no === "" &&
                                errors.mobile_no ===
                                  "*Fields can’t be blank. Please enter your mobile_no") ||
                              (phone.mobile_no.length > 0 &&
                                phone.mobile_no.length <= 9)
                                ? true
                                : false
                            }
                            labelText="Phone Number*"
                            controlClass={
                              (phone.mobile_no === "" &&
                                errors.mobile_no === "Phone is required") ||
                              (phone.mobile_no === "" &&
                                errors.mobile_no ===
                                  "*Fields can’t be blank. Please enter your mobile_no") ||
                              (phone.mobile_no.length > 0 &&
                                phone.mobile_no.length <= 9)
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>
                        {this.state.contact_detail.length > 1 ? (
                          <div className="col-2 restaurant_details_onboarding_minus_button">
                            <div>
                              <AddButtonIconComponent
                                buttonText="Delete"
                                onClick={this.onPhoneDeleteHandler(index)}
                                fontIcon="fa fa-trash-o"
                                colorCss="delete"
                              />
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ))}
                    <div className="col-12 pl-0 restaurant_details_onboarding_minus_button add_email_button bg-transparent mt-0">
                      <div>
                        <AddButtonIconComponent
                          buttonText="Add Another Phone Number"
                          onClick={this.onPhondeAddHandler}
                          fontIcon="fa fa-plus"
                          colorCss="blue"
                        />
                      </div>
                    </div>
                    <div className="row restaurant_details_onboarding_country_box mb-md-3 mb-lg-3 mb-xl-3 mt-4">
                      <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 new_Input_field_Section">
                        <NewSelectBoxInput
                          selectLabel="Country*"
                          name="country"
                          value={this.state.country}
                          onChange={this.selecthandleChange}
                          getCountries={getCountries}
                          en={en}
                          errorText={errors.country}
                          errorTrue={errors.country === "" ? true : false}
                        />
                      </div>
                      <div className="col-3 d-none d-md-block d-lg-block d-xl-block"></div>
                      <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 new_Input_field_Section">
                        <CurrencyPicker
                          name="currency*"
                          value={this.state.currency}
                          onChange={this.selecthandleChange}
                          errorTrue={errors.currency === "" ? true : false}
                          errorText={errors.currency}
                        />
                      </div>
                      <div className="col-3 d-none d-md-block d-lg-block d-xl-block"></div>
                      <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 new_Input_field_Section">
                        <TimeZoneCustom
                          name="timezone*"
                          value={this.state.timezone}
                          onChange={this.onChange}
                          errorTrue={errors.timezone === "" ? true : false}
                          errorText={errors.timezone}
                        />
                      </div>
                      <div className="col-3 d-none d-md-block d-lg-block d-xl-block"></div>

                      {/* <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-3 restaurant_details_onboarding_country_boxone">
                          <h4>Time Zone</h4>
                        </div>
                        <div className="col-8 col-sm-8 col-md-9 col-lg-9 col-xl-9 restaurant_details_onboarding_country_boxtwo">
                          <div className="restaurant_select_country">
                            <TimeZoneCustom
                              value={this.state.timezone}
                              name={"timezone"}
                              onChange={this.onChange}
                              className="inside_select-box border-0"
                            />
                            <Form.Text className="text-muted input-component-bottom">
                              {errors ? (
                                <div className="text-danger text-capitalize">
                                  {errors.timezone}
                                </div>
                              ) : null}
                            </Form.Text>
                          </div>
                        </div> */}
                    </div>
                    <hr />
                    <div className="row ">
                      <div className="col-12 map-button-box-main">
                        <DropDownBoxCrret
                          state={dropDownBox}
                          showText="See less details"
                          hideText="See more details"
                          onClick={this.dropDownBoxClick}
                        />
                        {dropDownBox ? (
                          <div className="col-12 p-0 mt-4 location-detections-popup-main h-50">
                            <div className="location-detections-popup-bodyBox">
                              <h5 className="col-12 p-0 d-flex location-detections-popup-headingfive">
                                Place ID:{" "}
                                <p className="location-detections-popup-paragraphfive">
                                  {google_place_id}
                                </p>
                              </h5>
                              <div className="row justify-content-between mt-4">
                                <div className="col-6">
                                  <NewInputText
                                    inputType="number"
                                    value={parseFloat(
                                      this.state.location.coordinates[0]
                                    ).toFixed(5)}
                                    labelText="Lattitude"
                                    disabled={true}
                                  />
                                </div>
                                <div className="col-6">
                                  <NewInputText
                                    inputType="number"
                                    value={parseFloat(
                                      this.state.location.coordinates[1]
                                    ).toFixed(5)}
                                    labelText="Longitude"
                                    disabled={true}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="onboarding-map-setup-screen-autodetect-button mt-2">
                      {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
                      <ReusableOnboardingLink
                        buttonTitle="Back Button"
                        buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                        buttonText="Back"
                        link={
                          this.props?.editDataAction
                            ? "/admin_edit_mapdetails_location"
                            : "/addvendormapdetailslocation"
                        }
                      />
                      <ReusableOnboardingButton
                        buttonTitle="Next Button"
                        buttonText="Next"
                        onClick={
                          actionButton === false
                            ? this.onActionButtonClick
                            : this.onChangeScreen
                        }
                        buttonClass={
                          name === "" ||
                          address === "" ||
                          area === "" ||
                          city === "" ||
                          pinCode === "" ||
                          businessState === "" ||
                          country === "" ||
                          currency === "" ||
                          timezone === "" ||
                          enquiry_email[0] === "" ||
                          contact_detail[0].mobile_no === "" ||
                          contact_detail[0].mobile_no.length <= 9 ||
                          contact_detail[contact_detail.length - 1]
                            .mobile_no === "" ||
                          contact_detail[contact_detail.length - 1].mobile_no
                            .length <= 9 ||
                          enquiry_email[enquiry_email.length - 1] === "" ||
                          !validEmailRegex.test(enquiry_email[0])
                            ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                            : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        }
                        disabled={
                          name === "" ||
                          address === "" ||
                          area === "" ||
                          city === "" ||
                          pinCode === "" ||
                          businessState === "" ||
                          country === "" ||
                          currency === "" ||
                          timezone === "" ||
                          enquiry_email[0] === "" ||
                          contact_detail[0].mobile_no === "" ||
                          contact_detail[0].mobile_no.length <= 9 ||
                          contact_detail[contact_detail.length - 1]
                            .mobile_no === "" ||
                          contact_detail[contact_detail.length - 1].mobile_no
                            .length <= 9 ||
                          enquiry_email[enquiry_email.length - 1] === "" ||
                          !validEmailRegex.test(enquiry_email[0])
                            ? true
                            : false
                        }
                      />
                      {/* </div> */}
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SuperAdminAddBusinessDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  storage: state.storage,
  onboardingData: state.superAdminOnboarding.restaurantDetails,
  editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
  editDataAction:
    state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_create_and_update_restaurant,
})(withRouter(SuperAdminAddBusinessDetails));

//03-09-2020
